import { apiClientWithMiddleware } from '../../../utils/API';
import { getPortalId } from '../../../utils/getPortalId';
const GROWTH_PROMPS_HAS_MODALS_API = 'growth-modals/v1/modals/has-modals';
export const getHasModals = ({
  location,
  windowLocation,
  contactId
}) => apiClientWithMiddleware().get(`${GROWTH_PROMPS_HAS_MODALS_API}?portalId=${getPortalId()}`, {
  query: {
    location,
    windowLocation,
    contactId
  }
});